import React from 'react';
import { searchProfileCatalogProducts, getProfileCatalogProductFileThumbnailUrl } from '@/services/profile-catalog-products';
import { debounce, isEqual } from 'lodash-es';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import ItemCategoryDisplay from '../item-categories/ItemCategoryDisplay';
import Autosuggest from 'react-autosuggest';
import { ProfileCatalogProduct } from '@/types';
import style from './Autocomplete.module.scss';
import { classnames } from '@/utils/html';
import { Trans } from '@lingui/react/macro';
import { MissingImage, Thumbnail } from '@ygtechnologies/bygr-frontend-component-library';

interface CatalogProductAutocompleteProps {
    profileId: number;
    filters?: object;
    onChange(suggestion: ProfileCatalogProduct): void;
}

interface CatalogProductAutocompleteState {
    searchText: string;
    products: (ProfileCatalogProduct | null)[];
    loading: boolean;
}

export default class CatalogProductAutocomplete extends React.Component<
    CatalogProductAutocompleteProps,
    CatalogProductAutocompleteState
> {
    state: CatalogProductAutocompleteState = {
        searchText: '',
        products: [],
        loading: false,
    };

    componentDidUpdate(prevProps) {
        const props = this.props;

        if (!isEqual(props.filters, prevProps.filters)) {
            this.doSearch();
        }
    }

    handleSearchChange = (e, { newValue }) => {
        this.setState({
            searchText: newValue,
        });
    };

    onSuggestionsFetchRequested = ({ value, reason }) => {
        if (reason === 'input-focused') {
            this.doSearch(value);
        } else {
            this.debouncedSearch(value);
        }
    };

    activeRequest: Promise<any[]> | null = null;
    async doSearch(value?) {
        const { profileId, filters } = this.props;
        const { searchText } = this.state;

        this.activeRequest = searchProfileCatalogProducts({
            ownerProfileId: profileId,
            searchText: value,
            ...filters,
        });

        this.setState({
            loading: true,
        });

        try {
            var result = await this.activeRequest;
            if (value === searchText) {
                this.setState({
                    products: result.length > 0 ? result : [null],
                });
            }
        } finally {
            this.setState({
                loading: false,
            });
        }

        // this.activeRequest.then(result => {
        //     if (value === searchText) {
        //         this.setState({
        //             products: result
        //         });
        //     }
        // }).finally(result => {
        //     this.setState({
        //         loading: false
        //     })
        // });
    }
    debouncedSearch = debounce(this.doSearch, 300);

    onSuggestionsClearRequested = () => {
        //TODO:Fix fetch abort
        // if(this.activeRequest) {
        //     this.activeRequest.abort();
        // }

        this.setState({
            products: [],
        });
    };

    handleSuggestionSelected = (e, { method, suggestion }) => {
        const { onChange } = this.props;
        triggerHandler(onChange, suggestion);
    };

    renderSuggestion = (product: ProfileCatalogProduct | null) => (
        <div className={style.suggestionContent}>
            {product ? (
                <>
                    <div className={classnames(style.suggestionAvatar, style.fitAvatar)}>
                        {product.images[0] ? (
                            <Thumbnail src={getProfileCatalogProductFileThumbnailUrl(product.images[0].id!)} />
                        ) : (
                            <MissingImage />
                        )}
                    </div>
                    <div className={style.suggestionText}>
                        <small>
                            <ItemCategoryDisplay value={product.itemCategoryId} />
                        </small>
                        <div>{product.name}</div>
                    </div>
                </>
            ) : (
                <div className={style.suggestionText}>
                    <div>{<Trans>No results</Trans>}</div>
                </div>
            )}
        </div>
    );

    render() {
        const { searchText, products } = this.state;

        const inputProps = {
            placeholder: 'Search...',
            value: searchText,
            onChange: this.handleSearchChange,
            type: 'search',
        };

        return (
            <Autosuggest
                theme={style}
                suggestions={products}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={(suggestion) => searchText}
                renderSuggestion={this.renderSuggestion}
                inputProps={inputProps}
                focusInputOnSuggestionClick={false}
                onSuggestionSelected={this.handleSuggestionSelected}
            />
        );
    }
}